import { assoc, compose, map, reduce, toPairs, when } from 'ramda'
import HttpCachePoolConfig from '../container/HttpCachePoolConfig'
import strategy from '../dictionary/strategy.json'

/**
 * Pool config provider class.
 */
class HttpCachePoolConfigProvider {
  /**
   * Constructor.
   *
   * @param {Object} configArray
   */
  constructor(configArray) {
    this.configContainers = compose(
      map(([name, config]) => new HttpCachePoolConfig(name, config)),
      toPairs,
    )(configArray)
  }

  /**
   * Provides the pool config container for a given requestPath.
   *
   * @param {String} path
   * @param {Object} parameters
   * @param {Boolean} localStorageAllowed
   * @return {HttpCachePoolConfig|null}
   */
  provide(path, parameters, localStorageAllowed) {
    return compose(
      when(
        (poolConfig) => !localStorageAllowed && poolConfig && poolConfig.strategy === strategy.localStorage,
        assoc('strategy', strategy.volatile),
      ),
      reduce((carry, poolConfig) => (poolConfig.test(path, parameters) ? poolConfig : carry), null),
    )(this.configContainers)
  }
}

export default HttpCachePoolConfigProvider
